/*
 * Copyright 2021 Larder Software Limited
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { ActivityStream } from './ActivityStream';
import { useProjectEntity, useProjectInfo, useStatuses } from '../../hooks';
import { useEntity } from '@backstage/plugin-catalog-react';
import { InfoCard } from '@backstage/core-components';

export const EntityJiraActivityStreamCard = () => {
  const { entity } = useEntity();
  const { projectKey, component, tokenType, label } = useProjectEntity(entity);
  const { statuses: statusNames } = useStatuses(projectKey);
  const { ticketIds } = useProjectInfo(
    projectKey,
    component,
    label,
    statusNames ?? [],
  );
  return (
    <InfoCard title="Activity Stream">
      <ActivityStream
        projectKey={projectKey}
        tokenType={tokenType}
        componentName={component}
        label={label}
        ticketIds={ticketIds}
      />
    </InfoCard>
  );
};
